/* empty css                              */
import f from "./td-longtail-vue-components98.js";
const t = "grid-column", l = {
  name: "GridColumn",
  props: {
    xs: { type: [Number, Boolean], default: !1 },
    sm: { type: [Number, Boolean], default: !1 },
    md: { type: [Number, Boolean], default: !1 },
    lg: { type: [Number, Boolean], default: !1 },
    xl: { type: [Number, Boolean], default: !1 },
    xsShrink: { type: Boolean },
    smShrink: { type: Boolean },
    mdShrink: { type: Boolean },
    lgShrink: { type: Boolean },
    xlShrink: { type: Boolean },
    xsOffset: { type: Number, default: void 0 },
    smOffset: { type: Number, default: void 0 },
    mdOffset: { type: Number, default: void 0 },
    lgOffset: { type: Number, default: void 0 },
    xlOffset: { type: Number, default: void 0 },
    xsSpacing: { type: Number, default: void 0 },
    smSpacing: { type: Number, default: void 0 },
    mdSpacing: { type: Number, default: void 0 },
    lgSpacing: { type: Number, default: void 0 },
    xlSpacing: { type: Number, default: void 0 },
    noPadding: { type: Boolean }
  },
  computed: {
    colClassList() {
      const s = [t];
      return this.xs || this.sm || this.md || this.lg || this.xl ? ["xs", "sm", "md", "lg", "xl"].forEach((e) => {
        this[e] === !0 ? s.push({ [`${t}--${e}`]: this[e] }) : s.push({
          [`${t}--${e}-${this[e]}`]: this[e]
        });
      }) : s.push(`${t}--is-simple`), Object.keys(this.$props).filter((e) => e.includes("Shrink")).forEach((e) => {
        this[e] && s.push(`${t}--${e.replace("Shrink", "-shrink")}`);
      }), Object.keys(this.$props).filter((e) => e.includes("Offset")).forEach((e) => {
        this[e] && s.push(`${t}--${e.replace("Offset", "-offset")}-${this[e]}`);
      }), Object.keys(this.$props).filter((e) => e.includes("Spacing")).forEach((e) => {
        this[e] && s.push(`${t}--${e.replace("Spacing", "-spacing")}-${this[e]}`);
      }), this.noPadding && s.push(`${t}--no-padding`), s;
    }
  }
};
var i = function() {
  var n = this, a = n._self._c;
  return a("div", { class: n.colClassList }, [n._t("default")], 2);
}, u = [], d = /* @__PURE__ */ f(
  l,
  i,
  u,
  !1,
  null,
  "5c2bdddb"
);
const m = d.exports;
export {
  m as default
};
